export default "0500e169353a3012.png"